var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
var PublicRoute = /** @class */ (function (_super) {
    __extends(PublicRoute, _super);
    function PublicRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PublicRoute.prototype.render = function () {
        var _a = this.props, authed = _a.authed, path = _a.path, component = _a.component;
        return (React.createElement(Route, { path: path, render: function () {
                return (authed
                    ? React.createElement(Redirect, { to: '/' })
                    : (function () { return component; })());
            } }));
    };
    return PublicRoute;
}(Component));
export { PublicRoute };
var mapStateToProps = function (state, nexProps) {
    return {
        authed: state.getIn(['authorize', 'authed', false])
    };
};
export default connect(mapStateToProps)(PublicRoute);



//////////////////
// WEBPACK FOOTER
// ./src/routes/PublicRoute.tsx
// module id = 888
// module chunks = 50